{
  "title": "Cannot remove {{ingredient}}",
  "message_one": "Remove this {{ingredient}} from the following snippet before continuing:",
  "message_other": "Remove this {{ingredient}} from the following snippets before continuing:",
  "close": "Close"
}
